import VaspSignupForm from './VaspSignupForm'

export default VaspSignupForm
